module.exports = __webpack_public_path__ + "static/media/حجوزات فنادق وتأجير أكواخ.2839bcd4.jpg";